import { FieldPath, UseFormReturn } from "react-hook-form";

import { SaveIndicator } from "./SaveIndicator";
import { useSaveIndicator } from "@/hooks/useSaveIndicator";
import { InfoTooltip } from "@/components/form/InfoTooltip";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { cn } from "@/lib/utils";

export const AutosaveFormLinkInput = <T extends Record<string, unknown>>({
  className,
  fieldName,
  form,
  infoTooltip,
  label,
  onBlur,
  placeholder,
}: {
  className?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  infoTooltip?: string;
  label?: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => Promise<void> | void;
  placeholder?: string;
}) => {
  const { handleChange, status } = useSaveIndicator();

  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            {label && (
              <FormLabel className="inline-flex w-full items-center justify-between">
                <span className="inline-flex items-center gap-1">
                  {label}
                  {infoTooltip && <InfoTooltip content={infoTooltip} />}
                </span>
                <SaveIndicator status={status} />
              </FormLabel>
            )}

            <FormControl>
              <Input
                {...field}
                className="bg-slate-50 text-black"
                onChange={(e) => {
                  field.onChange(e);
                  handleChange();
                }}
                onBlur={(e) => {
                  field.onBlur();
                  void onBlur(e);
                }}
                placeholder={placeholder ?? "-"}
                type="url"
                value={field.value as string}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
